import { Center, Divider, Heading, Image, VStack } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <Center mt="80px" fontFamily="Helvetica Neue">
      <VStack>
        <Image src="/logo.jpeg" height="24px" />
        <Divider my="20px" />
        <Heading>Sad As Duck Club</Heading>
        <Outlet />
        <Divider mt="10px" />
      </VStack>
    </Center>
  );
}
